module.exports = require('onyx-common/isFunction')
